import {mergeQueryKeys} from "@lukemorales/query-key-factory";
import {Auth} from "@/Service/Api/V1/QueryKeys/Auth";
import {Users} from "@/Service/Api/V1/QueryKeys/Users";
import {Teams} from "@/Service/Api/V1/QueryKeys/Teams";
import {Clients} from "@/Service/Api/V1/QueryKeys/Clients";
import {Notifications} from "@/Service/Api/V1/QueryKeys/Notifications";
import {Audits} from "@/Service/Api/V1/QueryKeys/Audits";
import {Exports} from "@/Service/Api/V1/QueryKeys/Exports";
import {GtaRates} from "@/Service/Api/V1/QueryKeys/GtaRates";
import {Misc} from "@/Service/Api/V1/QueryKeys/Misc";

export const QueryKeys = mergeQueryKeys(
    Auth,
    Users,
    Teams,
    Clients,
    Notifications,
    Audits,
    Exports,
    GtaRates,
    Misc
);